<template>
    <div id="step">
        <div
            :class="{
                selected: sidePanelVisible && selected && selected._id === step._id,
            }"
            class="d-flex flex-column align-items-center mb-5 chatbotStepContainer"
        >
            <div
                :id="'stepId' + step._id"
                v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                :class="{
                    'cb-selected': (selected && selected._id === step._id) || path.includes(step._id),
                    [step.type]: true,
                    'bg-danger': step.closeChat,
                    'text-white':
                        step.closeChat ||
                        (!step.closeChat && !!!step.nextStepId && step.type === 'content') ||
                        (step.type === 'form' && !!!step.nextStepId),
                    'bg-warning':
                        (!step.closeChat && !!!step.nextStepId && step.type === 'content') ||
                        (step.type === 'form' && !!!step.nextStepId),
                }"
                :content="tippyMessage('content', null)"
                class="cb-item cb-item-main"
            >
                <div class="cb-content h-100">
                    <div
                        class="text"
                        @click="
                            () => {
                                select(step);
                                selectedButton = null;
                            }
                        "
                    >
                        {{ step.description }}
                    </div>
                    <a-dropdown
                        v-if="!this.step.closeChat && this.step.type !== 'menu'"
                        :trigger="['click']"
                        class="arrow"
                    >
                        <a-menu slot="overlay" @click="(e) => addStep(e, step._id)">
                            <a-menu-item key="content">
                                {{ $t("message.contentStep") }}
                            </a-menu-item>
                            <a-menu-item key="form">
                                {{ $t("message.formStep") }}
                            </a-menu-item>
                            <a-menu-item key="menu">
                                {{ $t("message.menuStep") }}
                            </a-menu-item>
                        </a-menu>
                        <a-button class="p-0" style="z-index: 1">+</a-button>
                    </a-dropdown>
                    <md-icon
                        v-if="!step.closeChat && step.type !== 'menu' && step.nextStepId !== null"
                        class="cb-arrow"
                    >
                        south
                    </md-icon>
                </div>
            </div>

            <div v-if="step.type === 'menu'" class="d-flex justify-content-between mt-3">
                <div
                    v-for="menuItem in step.menuItems"
                    :id="'buttonId' + menuItem._id"
                    :key="menuItem._id"
                    v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                    :class="{
                        'cb-selected':
                            (selectedButton && selectedButton._id === menuItem._id) || path.includes(menuItem._id),
                        'bg-warning': !chatSteps.find((x) => x._id === menuItem.nextStepId),
                        'text-white': !chatSteps.find((x) => x._id === menuItem.nextStepId),
                    }"
                    :content="tippyMessage('menu', menuItem)"
                    class="cb-item mr-3 p-1 menuItem"
                    @click="
                        () => {
                            select(step, true);
                            selectedButton = menuItem;
                        }
                    "
                >
                    <span>{{ menuItem.title }}</span>
                    <a-dropdown
                        v-if="!chatSteps.find((x) => x._id === menuItem.nextStepId)"
                        :trigger="['click']"
                        class="arrow"
                    >
                        <a-menu
                            slot="overlay"
                            @click="
                                (e) =>
                                    addStep(e, null, menuItem).then((newButton) => {
                                        selectedButton = newButton;
                                    })
                            "
                        >
                            <a-menu-item key="content">
                                {{ $t("message.contentStep") }}
                            </a-menu-item>
                            <a-menu-item key="form">
                                {{ $t("message.formStep") }}
                            </a-menu-item>
                            <a-menu-item key="menu">
                                {{ $t("message.menuStep") }}
                            </a-menu-item>
                        </a-menu>
                        <a-button class="p-0">+</a-button>
                    </a-dropdown>
                </div>
                <div v-if="step.showPrevMenuButton" class="cb-item mr-3 p-1">
                    <span>{{ $t("message.prevStep") }}</span>
                </div>
                <div v-if="step.showLiveChatButton" class="cb-item mr-3 p-1">
                    <span>{{ $t("message.goToLive") }}</span>
                </div>
            </div>
        </div>

        <Step
            v-if="step.nextStepId !== null"
            :add-step="addStep"
            :path="path"
            :select="select"
            :selected="selected"
            :sidePanelVisible="sidePanelVisible"
            :step="chatSteps.find((x) => x._id === step.nextStepId)"
        />

        <Step
            v-if="
                selectedButton &&
                selectedButton.nextStepId !== null &&
                chatSteps.find((x) => x._id === selectedButton.nextStepId)
            "
            :key="selectedButton && selectedButton._id"
            :add-step="addStep"
            :path="path"
            :select="select"
            :selected="selected"
            :sidePanelVisible="sidePanelVisible"
            :step="chatSteps.find((x) => x._id === selectedButton.nextStepId)"
        />
    </div>
</template>

<script>
import { mapState } from "vuex";
import log2 from "../utils/log2";

const log = log2("Step");
export default {
    name: "Step",
    props: ["step", "select", "selected", "addStep", "path", "sidePanelVisible"],
    computed: {
        ...mapState({
            chatSteps: (state) => state.chatbot.chatbot.steps,
        }),
    },
    data() {
        return {
            selectedButton: null,
            id: Math.ceil(Math.random() * 100),
        };
    },
    updated() {
        log("Step updated", this.id);
        let pathSteps = this.chatSteps.filter((x) => this.path.join().indexOf(x._id.toString()) !== -1);
        if (pathSteps.length > 0) {
            const isConnected = pathSteps.map((x) => x.nextStepId).includes(this.step._id);
            const isMenuConnected = !!pathSteps.find((x) => !!x.menuItems.find((x) => x.nextStepId === this.step._id));
            if (!(isConnected || isMenuConnected)) {
                log("selectedButton null -> reason 1", { pathSteps, currentStep: this.step, path: this.path });
                this.selectedButton = null;
            }
        } else {
            log("selectedButton null -> reason 2", { pathSteps, currentStep: this.step, path: this.path });
            this.selectedButton = null;
        }
    },
    methods: {
        tippyMessage(type, item) {
            if (type === "content") {
                if (
                    (!this.step.closeChat && !!!this.step.nextStepId && this.step.type === "content") ||
                    (this.step.type === "form" && !!!this.step.nextStepId)
                ) {
                    return this.$t("chatbot.warnStep");
                } else if (this.step.closeChat) {
                    return this.$t("chatbot.finishStep");
                }
            }
            if (type === "menu") {
                const maybeNextStep = !!this.chatSteps.find((x) => x._id === item.nextStepId);
                if (!maybeNextStep) {
                    return this.$t("chatbot.warnStep");
                }
            }
            return "step";
        },
    },
};
</script>

<style lang="scss" scoped>
.cb-item {
    background-color: white;

    color: black;
    position: relative;
    cursor: pointer;
    user-select: none;
    transition: all 0.3s;
    box-shadow: 0 0 3px #00000080;

    .text {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
    }

    &:hover {
        background-color: lightgray;

        .arrow {
            background-color: lightgray;
            opacity: 1;
        }
    }

    .arrow {
        width: 20px;
        height: 20px;
        position: absolute;
        bottom: -25px;
        opacity: 0;
        transition: all 0.3s;
        border-radius: 50%;
        text-align: center;
        left: 50%;
        transform: translateX(-50%);
        box-shadow: 0 0 3px #00000080;
    }
}

.content {
    min-width: 150px;
    height: 30px;
    border-radius: 15px;
}

.menu {
    min-width: 150px;
    height: 30px;
    border-radius: 100%;

    &:after {
        border-radius: 100% !important;
    }
}

.menuItem {
    border-radius: 3px;
    padding: 4px 12px !important;
}

.form {
    min-width: 150px;
    height: 30px;
    transform: skew(-20deg);

    > .cb-content {
        transform: skew(20deg);
    }
}

.cb-selected {
    background-color: cornflowerblue;
    color: white;
}

.cb-arrow {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -35px;
}

.chatbotStepContainer.selected {
    .cb-item-main:after {
        content: "";
        border-radius: 16px;
        width: 100%;
        position: absolute;
        height: inherit;
        top: 0px;
        left: 0px;

        box-shadow: 0 0 0 0 #448affff;
        transform: scale(1);
        animation: pulse 2s infinite;
    }

    @keyframes pulse {
        0% {
            transform: scale(0.95);
            box-shadow: 0 0 0 0 #448affee;
        }

        70% {
            transform: scale(1);
            box-shadow: 0 0 0 10px #448aff00;
        }

        100% {
            transform: scale(0.95);
            box-shadow: 0 0 0 0 #448aff00;
        }
    }
}
</style>
